import React from "react";
import HeroSection from "../components/HeroSection";
import { heroSections } from "../constants/data.ts";

const FAQs = () => {
  return (
    <main className="bg-background">
      <HeroSection {...heroSections.faqs} />

      <section className="py-16 md:py-24 px-outer">
        <div className="container mx-auto max-w-3xl space-y-4">
          <h2 className="heading-main text-center mb-12">
            Effective Date: 27/01/2022
          </h2>
          <details className="card p-6">
            <summary className="font-rubik font-bold text-secondary cursor-pointer">
              What services does Westlisoft offer?
            </summary>
            <p className="text-body mt-4">
              We offer application development, digital marketing, staffing
              services, corporate training, RCM services, and travel solutions.
            </p>
          </details>
          <details className="card p-6">
            <summary className="font-rubik font-bold text-secondary cursor-pointer">
              How can I contact the team?
            </summary>
            <p className="text-body mt-4">
              You can reach us at info@westlisoft.com, call +91 8977937065, or
              chat on WhatsApp at the same number.
            </p>
          </details>
          <details className="card p-6">
            <summary className="font-rubik font-bold text-secondary cursor-pointer">
              Do you provide industry-specific solutions?
            </summary>
            <p className="text-body mt-4">
              Yes, we serve healthcare, finance, education, retail, travel and
              manufacturing sectors with tailored solutions.
            </p>
          </details>
          <details className="card p-6">
            <summary className="font-rubik font-bold text-secondary cursor-pointer">
              What services does Westlisoft Technologies provide?
            </summary>
            <p className="text-body mt-4">
              Westlisoft Technologies offers a range of services, including staffing solutions, digital marketing services, custom application development, corporate training programs, and consulting services. We specialize in helping businesses thrive in the digital age and build their workforce.
            </p>
          </details>
          <details className="card p-6">
            <summary className="font-rubik font-bold text-secondary cursor-pointer">
              How can I contact Westlisoft Technologies?
            </summary>
            <p className="text-body mt-4">
              You can reach us through our website’s “Contact Us” page, where you’ll find a contact form, email address, and phone number. We aim to respond to inquiries within one business day.
            </p>
          </details>
          <details className="card p-6">
            <summary className="font-rubik font-bold text-secondary cursor-pointer">
              Can you provide more information about your staffing services?
            </summary>
            <p className="text-body mt-4">
              Certainly! Our staffing services encompass temporary, permanent, and contract staffing solutions across various industries. We connect businesses with qualified candidates to meet their staffing needs.
            </p>
          </details>
          <details className="card p-6">
            <summary className="font-rubik font-bold text-secondary cursor-pointer">
              Tell me about your digital marketing services.
            </summary>
            <p className="text-body mt-4">
              Our digital marketing services include search engine optimization (SEO), pay-per-click advertising, social media marketing, content marketing, email marketing, and web design. We develop customized strategies to enhance online presence and drive business growth.
            </p>
          </details>
          <details className="card p-6">
            <summary className="font-rubik font-bold text-secondary cursor-pointer">
              What kind of applications can you develop?
            </summary>
            <p className="text-body mt-4">
              We have experience in developing a wide range of applications, including web and mobile apps, e-commerce platforms, CRM systems, and custom software solutions tailored to your business needs.
            </p>
          </details>
          <details className="card p-6">
            <summary className="font-rubik font-bold text-secondary cursor-pointer">
              Do you offer corporate training programs?
            </summary>
            <p className="text-body mt-4">
              Yes, we provide corporate training programs designed to enhance the skills and knowledge of your workforce. Our training covers various areas such as technology, leadership, soft skills, and industry-specific training.
            </p>
          </details>
          <details className="card p-6">
            <summary className="font-rubik font-bold text-secondary cursor-pointer">
              Can you explain your consulting services?
            </summary>
            <p className="text-body mt-4">
              Our consulting services involve working closely with businesses to identify challenges, develop strategies, and implement solutions to achieve their goals. We provide expert guidance in areas such as IT, digital transformation, and business process optimization.
            </p>
          </details>
          <details className="card p-6">
            <summary className="font-rubik font-bold text-secondary cursor-pointer">
              What industries do you have experience working with?
            </summary>
            <p className="text-body mt-4">
              Toggle Content
            </p>
          </details>
          <details className="card p-6">
            <summary className="font-rubik font-bold text-secondary cursor-pointer">
              Do you have a track record of successful projects or clients?
            </summary>
            <p className="text-body mt-4">
              Yes, we have a portfolio of successful projects and satisfied clients. You can visit our “Portfolio” page on our website to see examples of our work and read case studies.
            </p>
          </details>
          <details className="card p-6">
            <summary className="font-rubik font-bold text-secondary cursor-pointer">
              How do you ensure data security and confidentiality?
            </summary>
            <p className="text-body mt-4">
              We take data security and confidentiality seriously. We use industry-standard security measures, confidentiality agreements, and best practices to protect your sensitive information and data.
            </p>
          </details>
          <details className="card p-6">
            <summary className="font-rubik font-bold text-secondary cursor-pointer">
              What is the typical duration for application development projects?
            </summary>
            <p className="text-body mt-4">
              Project durations vary depending on the complexity of the application. We’ll work with you to define project timelines during the initial consultation, and we strive to meet agreed-upon deadlines.
            </p>
          </details>
          <details className="card p-6">
            <summary className="font-rubik font-bold text-secondary cursor-pointer">
              Can you provide references or client testimonials?
            </summary>
            <p className="text-body mt-4">
              Yes, we can provide references and testimonials upon request. Feel free to reach out to us for this information.
            </p>
          </details>
          
        </div>
      </section>
    </main>
  );
};

export default FAQs;
